import { Component, ChangeDetectionStrategy, Input } from '@angular/core'

@Component({
  selector: 'icos-button-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class]="'icos-button-group ' + nativeClass">
      <ng-content></ng-content>
    </div>
  `
})
export class IcosButtonGroup {
  @Input('class') nativeClass: string = ''

  constructor() {}
}
